// extracted by mini-css-extract-plugin
export default {"formText":"custom-input_formText__9KLex"};